module.exports = __webpack_public_path__ + "img/users.c76e4593.svg";